import { render, staticRenderFns } from "./DataAuthUser.vue?vue&type=template&id=342fcf73"
import script from "./DataAuthUser.vue?vue&type=script&lang=js"
export * from "./DataAuthUser.vue?vue&type=script&lang=js"
import style0 from "./DataAuthUser.vue?vue&type=style&index=0&id=342fcf73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports